import axios from "axios"

const actionSaveMilkControl = async (_, payload) => {
  await axios.post(`${process.env.VUE_APP_URL_API}/v1/services/${payload.service_id}/milk_analysis`, {...payload.service});
}

const actionEditMilkControl = async (_, payload) => {
  await axios.put(`${process.env.VUE_APP_URL_API}/v1/services/${payload.service_id}/milk_analysis`, {...payload.service});
}

const actionDeleteMilkControl = async (_, payload) => {
  await axios.delete(`${process.env.VUE_APP_URL_API}/v1/services/${payload.id}/clear_milk_analysis`);
}

const actionGetLabSync = async (_, payload) => {
  const response = await axios.get(`${process.env.VUE_APP_URL_API}/v1/integrations/milk_analysis_sync`, {params: payload});
  return response.data;
}

export default {
  actionSaveMilkControl,
  actionEditMilkControl,
  actionDeleteMilkControl,
  actionGetLabSync
}
